module.exports = "/assets/images/copy_e8d13c.svg";